import { render, staticRenderFns } from "./r-reward-view.vue?vue&type=template&id=5b7b04e3"
import script from "./r-reward-view.vue?vue&type=script&lang=js"
export * from "./r-reward-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b7b04e3')) {
      api.createRecord('5b7b04e3', component.options)
    } else {
      api.reload('5b7b04e3', component.options)
    }
    module.hot.accept("./r-reward-view.vue?vue&type=template&id=5b7b04e3", function () {
      api.rerender('5b7b04e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/reward/r-reward-view.vue"
export default component.exports